import { orderTotalDisplayStyles } from "@insite/content-library/Components/OrderTotalDisplay";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const commonStyes = `
    font-size: 16px;
    line-height: 32px;
`;

orderTotalDisplayStyles.container = {
    gap: 0,
    css: css`
        background: white;
        padding: 0;
        padding: 10px 0;
        border-top: 1px solid ${getColor("text.main")};
        border-bottom: 1px solid ${getColor("text.main")};
    `,
};

orderTotalDisplayStyles.subtotalLabelGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.subtotalValueGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.discountsLabelGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.discountsValueGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.shippingAndHandlingLabelGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.shippingAndHandlingValueGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.otherChargesLabelGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.otherChargesValueGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.taxLabelGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.taxValueGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.totalLabelGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
orderTotalDisplayStyles.totalValueGridItem = {
    width: 6,
    css: css`
        ${commonStyes};
    `,
};
